import React, { useState } from 'react';
import { XMarkIcon, InformationCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { usePopup } from '../../../context/PopupContext';

const PopupPreview = ({ isOpen, onClose, popup }) => {
    const [doNotShowAgain, setDoNotShowAgain] = useState(false);
    const { markPopupAsDoNotShow } = usePopup();
    

    if (!popup) return null;

    // Détermine le style selon le type de popup en utilisant les classes de l'application
    const getTypeStyles = () => {
        switch (popup.type) {
            case 'warning':
                return {
                    icon: <ExclamationTriangleIcon className="w-7 h-7 text-warning" />,
                    headerClass: 'bg-warning/10 border-warning border-opacity-20',
                    titleClass: 'text-warning-content',
                    iconBg: 'bg-warning/20',
                    buttonClass: 'btn-warning',
                    titleLabel: 'Attention'
                };
            case 'info':
            default:
                return {
                    icon: <InformationCircleIcon className="w-7 h-7 text-primary" />,
                    headerClass: 'bg-primary/10 border-primary border-opacity-20',
                    titleClass: 'text-primary',
                    iconBg: 'bg-primary/20',
                    buttonClass: 'btn-primary',
                    titleLabel: 'Information'
                };
        }
    };

    const typeStyles = getTypeStyles();

    // Animation d'entrée/sortie
    const overlayClass = isOpen
        ? 'opacity-100 pointer-events-auto'
        : 'opacity-0 pointer-events-none';

    const modalClass = isOpen
        ? 'translate-y-0 scale-100'
        : 'translate-y-4 scale-95';

    // Gérer la fermeture du popup avec l'option "Ne plus afficher"
    const handleClose = () => {
        if (doNotShowAgain && popup.id && !location.pathname.includes('admin')) {
            markPopupAsDoNotShow(popup.id);
        }

        // Appeler la fonction de fermeture
        onClose();
    };

    const handleDoNotShowAgain = (e) => {
        setDoNotShowAgain(e.target.checked);
    };

    const addStyleToLinks = (content) => {
        return content.replace(/<a/g, '<a class="link link-primary"');
    }

    return (
        <div
            className={`fixed inset-0 bg-base-100/40 backdrop-blur-sm flex items-center justify-center z-[1000] transition-all duration-300 ${overlayClass}`}
            onClick={handleClose}
        >
            <div
                className={`bg-base-100 rounded-lg shadow-xl w-11/12 max-w-xl transform transition-all duration-300 ${modalClass}`}
                onClick={e => e.stopPropagation()}
            >
                <div className={`flex items-center p-4 border-b ${typeStyles.headerClass}`}>
                    <div className={`p-2 rounded-full mr-3 ${typeStyles.iconBg}`}>
                        {typeStyles.icon}
                    </div>
                    <h2 className={`text-xl font-bold flex-1 ${typeStyles.titleClass}`}>
                        {typeStyles.titleLabel} : {popup.title}
                    </h2>
                    <button
                        className="btn btn-ghost btn-sm btn-circle"
                        onClick={handleClose}
                        aria-label="Fermer"
                    >
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                </div>

                <div
                    className="p-5 max-h-[60vh] overflow-y-auto prose prose-sm md:prose-base max-w-none"
                    dangerouslySetInnerHTML={{ __html: addStyleToLinks(popup.content) }}
                />

                <div className="border-t border-base-300 p-4">
                    <div className="flex items-center mb-3">
                        <label className="cursor-pointer label flex items-center justify-start gap-2">
                            <input
                                type="checkbox"
                                className="checkbox checkbox-sm checkbox-primary"
                                checked={doNotShowAgain}
                                onChange={handleDoNotShowAgain}
                            />
                            <span className="label-text">Ne plus afficher</span>
                        </label>
                    </div>

                    <div className="flex justify-end">
                        <button
                            className={`btn ${typeStyles.buttonClass}`}
                            onClick={handleClose}
                        >
                            Fermer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupPreview; 